export enum ValueType {
  TOTAL_DETECTED = "TotalDetected",
  INCORRECTLY_DETECTED = "InCorrectlyDetected",
  MANUALLY_ADDED = "ManuallyAdded"
}

export enum FilterType {
  Most_Correctly_Detected = "MostCorrectlyDetected",
  Most_Incorrectly_Detected = "MostIncorrectlyDetected",
  Most_Manually_Added = "MostManuallyAdded"
}

export enum DetectedType {
  Correctly_Detected = "CorrectlyDetected",
  Incorrectly_Detected = "InCorrectlyDetected",
  Manually_Added = "ManuallyAdded"
}

export enum Duration {
  LAST_3_MONTHS = "Last 3 Months",
  LAST_6_MONTHS = "Last 6 Months",
  LAST_12_MONTHS = "Last 12 Months"
}
